import { useTranslation } from "react-i18next";
import TabsNavigationBar from "../../components/bar/TabsNavigationBar/TabsNavigationBar";

function DocumentsNavigationBar(props) {
    const { t } = useTranslation();
    return (
        <TabsNavigationBar
            multipleLocationKey={props.multipleLocationKey}
            pages={[
                {
                    label: t("headers.products"),
                    link: "/sales-manager/documents/",
                },
                {
                    label: t("headers.investment_prospectus"),
                    link: "/sales-manager/investment_prospectus/",
                },
            ]}
        />
    );
}

export default DocumentsNavigationBar;
